module.exports = __webpack_public_path__ + "img/ch_wymf.e07210d5.png";